import Vue from 'vue'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import Buefy from 'buefy'
import App from './components/App'
import Entry from './components/view/Entry'
import Login from "./components/pages/Login"
import store from './store'
import DashBoard      from "./components/pages/Dashboard"
import GraphPage      from "./components/pages/dashboard/GraphPage"
import Variables      from './components/pages/dashboard/group/Variables'
import GroupSetting   from './components/pages/dashboard/group/GroupSetting'
import Members        from './components/pages/dashboard/group/Members'
import DeviceMonitor  from './components/pages/DeviceMonitor'
import SimpleGraph    from './components/pages/SimpleGraph'
import NotFound from "./components/pages/NotFound"
import {messages} from "./lib/language"

Vue.use(VueRouter)
Vue.use(Buefy)
Vue.use(VueI18n)

Vue.config.productionTip = false
// 謎のエラーがでる問題(2020/02/21現在)
// TODO: あとで再調査する
// https://github.com/vuetifyjs/vuetify/issues/9999
// {{{
// eslint-disable-next-line no-unused-vars
Vue.config.warnHandler = function (msg, vm, trace) {
  const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <a>.';
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
}
// }}}

// 認証が必要なページのルーティング
// beforeEnter をつける
// { path: '/dashboard/user/:userID', component: UserPage, beforeEnter: requireAuth }
// eslint-disable-next-line no-unused-vars
const requireAuth = (to, from, next) => {
  const authenticated = store.getters['account/authenticated']
  if (authenticated) {
    next()
  } else {
    next('/login')
  }
}

const ifInitialized = (to, from, next) => {
  const initialized = store.getters['account/initialized']
  if (initialized) {
    next('/dashboard/')
  } else {
    next()
  }
}

const routes = [
  { path: '/', component: App,
    children: [
      { path: '/login', component: Login, beforeEnter: ifInitialized },
      { path: '/signin', component: Login, beforeEnter: ifInitialized },
      { path: '/graph/:graphID', component: SimpleGraph},
      { path: '/dashboard', component: DashBoard,
        children: [
          { path: '', component: Variables },
          // { path: '/dashboard/graph/:VariableID', component: GraphPage },
          { path: '/dashboard/device/', component: DeviceMonitor },
          { path: '/dashboard/group', component: NotFound },
          { path: '/dashboard/group/:groupId/variables', component: Variables, props: true },
          { path: '/dashboard/group/:groupId/members', component: Members, props: true },
          { path: '/dashboard/group/:groupId/setting', component: GroupSetting, props: true },
          { path: '/dashboard/group/:groupId/graph/:VariableID', component: GraphPage, props: true },
        ]
      },
      { path: "/error", component: NotFound},
    ]
  },
  { path: '*', component: NotFound},
]

const router = new VueRouter({
  base: '/',
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  const code = to.query.code
  const gpath = to.path.split('/')[1]
  if (to.path === "/login" || to.path === "/signin") { // 初回ログイン画面時
    next()
  } else if (gpath === 'graph') {
    next()
  } else if (code) { // Cognito認証でCodeが返ってきた時
    store.dispatch('account/authorization', code)
    .then(() => {
      next('/dashboard/')
    })
    .catch(e => {
      next(e)
    })
  } else { // 一時利用
    if (store.getters['account/initialized']) {
      if (store.state.account.name !== "")
        next()
      else {
        store.dispatch('account/getUser')
        .catch(e => {
          if (e.message == `"user not found"\n`) {
              return store.dispatch('account/logout')
              .then(() => next('login', () => {}))
          } else {
            return Promise.reject(e)
          }
        })
        .then(() => {
          next()
        })
      }
    } else {
      next('/login')
    }
  }
})

router.afterEach((to) => {
  if (window.location.hostname == "beta.tfabconnect.com") {
    // eslint-disable-next-line no-undef
    gtag('config', 'UA-149671383-1', {
      'page_path': to.path
    });
  }
})

router.onError(e => {
  console.error(e)
})

new Vue({
  router,
  store,
  i18n: new VueI18n({
    locale: store.state.preferences.locale,
    messages
  }),
  render: h => h(Entry)
}).$mount('#app')
